<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
  <path d="M300.13,149.81c0,82.4-67.38,149.46-150.11,149.46C71,299.27,5.25,237.89-.1,159.5a9.71,9.71,0,0,1,6-9.67,10.24,10.24,0,0,1,11.34,2C36.92,171.51,61,182.2,85,182.2a96.45,96.45,0,0,0,96.4-96.4c0-24.36-10.67-48.37-30.36-68a9.73,9.73,0,0,1-2-11,10.76,10.76,0,0,1,9.67-6c79.41,4.32,141.46,70,141.46,149.09Z"/>
</svg>
